import { render, staticRenderFns } from "./CompanyList.vue?vue&type=template&id=10bea934&scoped=true"
import script from "./CompanyList.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompanyList.vue?vue&type=style&index=0&id=10bea934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bea934",
  null
  
)

export default component.exports